import { render, staticRenderFns } from "./account_extract.vue?vue&type=template&id=2f18a2d2&scoped=true"
import script from "./account_extract.vue?vue&type=script&lang=js"
export * from "./account_extract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f18a2d2",
  null
  
)

export default component.exports